import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { AccessControl, MuiButton } from "@ryde/controls";
import {
  ActionsEnum,
  DrawerType,
  ImportAreaTypeEnum,
  useDrawers,
} from "@ryde/shared";

export const AreaHeaderRightActions: FC = () => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawers();

  const handleImportAreasClick = useEvent(() => {
    openDrawer({
      drawerProps: {
        type: DrawerType.ImportAreas,
        importType: ImportAreaTypeEnum.INSERT_AREAS,
        title: t("area.formLabel.importAreas"),
      },
    });
  });

  return (
    <AccessControl entity="system" action={ActionsEnum.AllowImport}>
      <MuiButton onClick={handleImportAreasClick} sx={{ flexShrink: 0 }}>
        {t(`area.formLabel.importAreas`)}
      </MuiButton>
    </AccessControl>
  );
};
